export default __webpack_public_path__ + "static/dispatch-3-191cc0cff7e929736014cac05fa906d3.png";